import "/app/apps/news/sentry.client.config.ts";
import { init } from 'astro/virtual-modules/prefetch.js';init()